export const enterpriseRouteEntries = {
  enterpriseAdmin: () => import('./presentation/EnterpriseAdminPage'),
} as const;